import PropTypes from 'prop-types'

export const FAQItem = ({ question, answer, isOpen, onToggle }) => (
  <div className="border border-dark-border rounded-lg mb-4">
    <button
      onClick={onToggle}
      className="w-full px-6 py-4 text-left bg-dark-tertiary hover:bg-dark-border transition-colors rounded-lg flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-gray-900"
      aria-expanded={isOpen}
    >
      <span className="text-white font-medium">{question}</span>
      <span className="text-gray-400 text-xl" aria-hidden="true">
        {isOpen ? '−' : '+'}
      </span>
    </button>
    {isOpen && (
      <div className="px-6 py-4 bg-dark-secondary border-t border-dark-border">
        <div className="text-gray-300 space-y-3">{answer}</div>
      </div>
    )}
  </div>
)

FAQItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
}

export default FAQItem
